import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const createContactForm = async (payload) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.MESSAGING.CREATE_CONTACT_FORM,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Failed to create send contact form:', error);
    console.log('Server error response:', error?.response?.data);
    throw error;
  }
};

export const fetchContactFormInbox = async () => {
  try {
    const response = await apiClient.get(
      API_ENDPOINTS.MESSAGING.CONTACT_FORM_INBOX
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch contact form inbox:', error);
    console.log('Server error response:', error?.response?.data);
    throw error;
  }
};

export const fetchContactFormUnreadCount = async () => {
  try {
    const response = await apiClient.get(
      API_ENDPOINTS.MESSAGING.CONTACT_FORM_UNREAD
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch contact form unread count:', error);
    console.log('Server error response:', error?.response?.data);
    throw error;
  }
};